import React from 'react';
import Reveal from '../Reveal';
import { visionImage } from '../../mock';
import { scrollToId } from '../Navbar';

export default function SpiritSection() {
  return (
    <section id="vision" className="bg-[#f4f1eb] py-28 md:py-40">
      <div className="flex flex-col md:flex-row items-stretch gap-14 md:gap-0">
        <div className="md:w-1/2 image-zoom overflow-hidden">
          <div className="aspect-[4/5] md:aspect-auto md:h-[720px]">
            <img
              src={visionImage}
              alt="The Spirit of Riva Build Group"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <div className="md:w-1/2 flex items-center px-6 md:px-16 lg:px-24">
          <Reveal className="max-w-lg">
            <div className="font-sans-ui text-[10px] tracking-[0.3em] text-[#5a5852] mb-7">
              Vision
            </div>
            <h2 className="font-serif-display text-[40px] md:text-[54px] lg:text-[62px] tracking-wide lowercase text-[#2b2a27] leading-[1.05]">
              the spirit of
              <br />
              <em className="italic font-light">riva build group</em>
            </h2>
            <p className="mt-9 text-[15px] leading-[1.9] text-[#5a5852]">
              Riva Build Group was founded to redefine the Los Angeles residential
              experience &mdash; to establish a new standard rooted in creativity,
              craftsmanship and conviction. Our approach is a delicate balance
              between tradition and innovation, timeless architecture and
              contemporary expression.
            </p>
            <p className="mt-5 text-[15px] leading-[1.9] text-[#5a5852]">
              Because we are a young studio, we are careful. We take on a
              limited number of projects a year, each one led personally by a
              founding partner, and built to a single standard of craft.
            </p>
            <div className="mt-12 flex flex-wrap gap-10">
              <button
                onClick={() => scrollToId('custom-homes')}
                className="font-serif-display italic text-[17px] text-[#2b2a27] underline-anim pb-1"
              >
                About our work
              </button>
              <button
                onClick={() => scrollToId('contact')}
                className="font-serif-display italic text-[17px] text-[#2b2a27] underline-anim pb-1"
              >
                Enquire today
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
